module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "ProductClassifySearchResultView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductClassifySearchResultView!./src/pages/Shop/Product/ProductClassifySearchResult/indexView.js
// module id = 870
// module chunks = 431